import {
  REBOOK_FETCH_DATA_SUCCESS,
  REBOOK_FETCH_DATA_FAILURE
} from "./constants";

const initState = {
  isSuccess: false
}

export function reducer(state = initState, action) {
  switch (action.type) {
    case REBOOK_FETCH_DATA_SUCCESS:
      return {
        ...state,
        isSuccess: action.payload
      };
    case REBOOK_FETCH_DATA_FAILURE:
      return {
        ...state,
      };

    default:
      return state;
  }
}
